import { WorkerStage } from "@clipboard-health/contract-worker-app-bff";
import { CalloutsWrapper } from "@clipboard-health/ui-components";
import { Box, Skeleton } from "@mui/material";

import { ActiveNegotiationsCallout } from "./ActiveNegotiationsCallout";
import { BookingRequestsCallout } from "./BookingRequestsCallout";
import { PendingBreakPaymentRequestsCallout } from "./PendingBreakPaymentRequestsCallout";
import { PendingSentHomeRequestsCallout } from "./PendingSentHomeRequestsCallout";
import { ShiftInviteCallout } from "./ShiftInviteCallout";
import { UnverifiedShiftsCallout } from "./UnverifiedShiftsCallout";

interface Props {
  shiftInviteCount: number;
  visitInviteCount: number;
  workerStage: WorkerStage;
  unverifiedShiftsCount: number;
  activeNegotiationsCount: number;
  extraWorkedRequestsCount: number;
  sentHomeRequestsCount: number;
  bookingRequestsCount: number;
  isLoadingInvites: boolean;
  isLoadingUnverifiedShifts: boolean;
  isLoadingNegotiations: boolean;
  isLoadingSentHome: boolean;
  isLoadingExtraWorked: boolean;
  isLoadingBookingRequests: boolean;
  isSeePastShiftsEnabled: boolean;
}

export function WorkerShiftsCalloutsContainer(props: Props) {
  const {
    shiftInviteCount,
    visitInviteCount,
    workerStage,
    unverifiedShiftsCount,
    activeNegotiationsCount,
    extraWorkedRequestsCount,
    sentHomeRequestsCount,
    bookingRequestsCount,
    isLoadingInvites,
    isLoadingUnverifiedShifts,
    isLoadingNegotiations,
    isLoadingSentHome,
    isLoadingExtraWorked,
    isLoadingBookingRequests,
    isSeePastShiftsEnabled,
  } = props;

  const isLoading =
    isLoadingInvites ||
    isLoadingUnverifiedShifts ||
    isLoadingNegotiations ||
    isLoadingSentHome ||
    isLoadingBookingRequests ||
    isLoadingExtraWorked;

  const totalInviteCount = shiftInviteCount + visitInviteCount;

  const shouldShowUnverifiedShifts = unverifiedShiftsCount > 0 && !isSeePastShiftsEnabled;

  const hasCallouts =
    totalInviteCount > 0 ||
    shouldShowUnverifiedShifts ||
    activeNegotiationsCount > 0 ||
    extraWorkedRequestsCount > 0 ||
    bookingRequestsCount > 0 ||
    sentHomeRequestsCount > 0;

  return (
    <Box sx={{ marginX: -4 }}>
      {isLoading && (
        <CalloutsWrapper sx={{ paddingX: 4 }}>
          {Array.from({ length: 2 }).map((_, index) => (
            <Skeleton
              // eslint-disable-next-line react/no-array-index-key
              key={`worker-shift-callout-skeleton-${index}`}
              variant="rounded"
              sx={{
                height: 36,
                width: "60%",
              }}
              aria-label="Loading shift notifications"
            />
          ))}
        </CalloutsWrapper>
      )}
      {!isLoading && hasCallouts && (
        <CalloutsWrapper sx={{ paddingX: 5 }}>
          {totalInviteCount > 0 && (
            <ShiftInviteCallout
              shiftInviteCount={shiftInviteCount}
              visitInviteCount={visitInviteCount}
              workerStage={workerStage}
            />
          )}
          {bookingRequestsCount > 0 && (
            <BookingRequestsCallout bookingRequestsCount={bookingRequestsCount} />
          )}
          {shouldShowUnverifiedShifts && (
            <UnverifiedShiftsCallout unverifiedShiftsCount={unverifiedShiftsCount} />
          )}
          {activeNegotiationsCount > 0 && (
            <ActiveNegotiationsCallout activeNegotiationsCount={activeNegotiationsCount} />
          )}
          {extraWorkedRequestsCount > 0 && (
            <PendingBreakPaymentRequestsCallout
              extraWorkedRequestsCount={extraWorkedRequestsCount}
            />
          )}
          {sentHomeRequestsCount > 0 && (
            <PendingSentHomeRequestsCallout sentHomeRequestsCount={sentHomeRequestsCount} />
          )}
        </CalloutsWrapper>
      )}
    </Box>
  );
}
